import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { signIn } from "../Redux/Reducers/UserSlice";

const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.user)

  const token = localStorage.getItem("token"); 

  if (!token) {
    return <Navigate to="/" replace />;
  }

  if (!user && token) {
    if (token) {
      dispatch(
        signIn({
          token,
        }),
      )
    }
  }

  return children;
};

export default PrivateRoute;
